import type { PropsWithChildren } from 'react'
import { Box } from '@mui/material'
import { PageHeader } from './PageHeader'
import {
  PageMainCenter,
  PageMainDefault,
  PageMainFull,
} from './PageMainContent'
import type { Props as DefaultHeaderProps } from '../Header/Header'

export type Props = {
  header:
    | (DefaultHeaderProps & { hideBorderBottom?: boolean })
    | { component: React.ReactNode }
  mainLayoutType?: 'default' | 'center' | 'full'
  // mainLayoutType が default の場合のみ表示できる
  bgWhiteContent?: React.ReactNode
  // ヘッダー直下、padding 領域の外に full-width で挿入するスロット。
  // mainLayoutType が default の場合のみ表示できる。
  subHeader?: React.ReactNode
  // children を囲む灰色領域の左右 padding を無効化する。
  // mainLayoutType が default の場合のみ有効。
  disableContentGutters?: boolean
  footer?: React.ReactNode
}

const styles = {
  page: {
    minHeight: '100dvh',
    display: 'flex',
    flexFlow: 'column',
  },
}

export function PageLayout({
  children,
  header,
  mainLayoutType = 'default',
  bgWhiteContent,
  subHeader,
  disableContentGutters,
  footer,
}: PropsWithChildren<Props>) {
  return (
    <Box sx={styles.page}>
      <PageHeader {...header} />
      {mainLayoutType === 'default' && (
        <PageMainDefault
          bgWhiteContent={bgWhiteContent}
          subHeader={subHeader}
          disableContentGutters={disableContentGutters}
        >
          {children}
        </PageMainDefault>
      )}
      {mainLayoutType === 'center' && (
        <PageMainCenter>{children}</PageMainCenter>
      )}
      {mainLayoutType === 'full' && <PageMainFull>{children}</PageMainFull>}
      {footer && (
        // fixed のため、フッターは PageMain と重なっている。フッターと PageMain が重ならないようにすることも検討した方が良いかもしれない。
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
          }}
        >
          {footer}
        </Box>
      )}
    </Box>
  )
}
